import {Component, Inject, OnInit} from '@angular/core';
import {AssistanceService} from '../../../../../domain/assistance/service/assistance.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {TypeAssistancesCategories} from '../../../../../domain/assistance/model/type-assistances-categories';
import {ImportanceCategories} from '../../../../../domain/assistance/model/importance-categories';
import {TypeAssistancesSubCategories} from '../../../../../domain/assistance/model/type-assistances-sub-categories';
import moment from 'moment';
import {Solutions} from '../../../../../domain/core/model/solutions';
import {UserContext} from '../../../../../application/app-context/user-context/user-context';
import {App} from '../../../../../domain/core/model/app';
import {UserContextService} from '../../../../../application/app-context/user-context/user-context.service';
import {Assistance} from '../../../../../domain/assistance/model/assistance';
import {AssistanceEventService} from '../../../../../domain/assistance/service/assistance-event.service';
import {Status} from '../../../../../domain/assistance/model/status';

@Component({
             selector: 'app-assistance-edit-dialog',
             templateUrl: './home-assistance-edit-dialog.component.html'
           })
export class HomeAssistanceEditDialogComponent implements OnInit {

  categories = Object.values(TypeAssistancesCategories);
  subCategories = Object.values(TypeAssistancesSubCategories);
  importanceList = Object.values(ImportanceCategories);
  statusList = Object.values(Status);

  newAssistance: Assistance | undefined;
  editedAssistance: Assistance | undefined;
  profileForm: FormGroup | undefined;
  solutions: Array<string> = [];
  userContext: UserContext | undefined;
  isCreation = true;

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<HomeAssistanceEditDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private userContextService: UserContextService,
              private assistanceEventService: AssistanceEventService,
              private assistanceService: AssistanceService) {
  }

  ngOnInit(): void {
    this.userContext = this.userContextService.getUserContext();
    this.initSolutions();
    this.isCreation = this.data == null;

    this.profileForm = new FormGroup({
                                       categorySelected: new FormControl(this.isCreation ?  TypeAssistancesCategories.assistance : this.data.assistance.category, Validators.required),
                                       subCategorySelected: new FormControl(this.isCreation ?  '' : this.data.assistance.subCategory),
                                       importanceSelected: new FormControl(this.isCreation ?  ImportanceCategories.high : this.data.assistance.importance, Validators.required),
                                       statusSelected: new FormControl(this.isCreation ? Status.done : this.data.assistance.status, Validators.required),
                                       solutionSelected: new FormControl(this.isCreation ? Solutions.insito : this.data.assistance.solution, Validators.required),
                                       publicationDate: new FormControl(this.isCreation ?  new Date() : this.data.assistance.publicationDate, Validators.required),
                                       label: new FormControl(this.isCreation ? '' : this.data.assistance.label, Validators.required)
                                     });
  }

  saveEvent(): void {
    if (this.isCreation) {
      this.addEvent();
    } else {
      this.editEvent();
    }
  }

  addEvent(): void {
    this.newAssistance = this.getValues();
    if (this.newAssistance) {
      this.assistanceService.addAssistance(this.newAssistance)
          .subscribe(() => {
                       this.dialogRef.close();
                       this.assistanceEventService.onChangeForAssistanceList.next();
                     },
                     error => console.error('Error while performing post...\n' + error));
    }
  }

  editEvent(): void {
    this.editedAssistance = this.updateValues(this.data.assistance);
    this.assistanceService.editAssistance(this.editedAssistance)
        .subscribe(() => {
                     this.dialogRef.close();
                     this.assistanceEventService.onChangeForAssistanceList.next();
                   },
                   error => console.error('Error while performing post...\n' + error));
  }

  getValues(): Assistance | undefined {
    if (this.profileForm) {
      return new Assistance(null,
                            null,
                            this.profileForm.get('label')?.value,
                            new Date(),
                            new Date(),
                            this.profileForm.get('categorySelected')?.value,
                            this.profileForm.get('subCategorySelected')?.value,
                            this.profileForm.get('statusSelected')?.value,
                            this.profileForm.get('importanceSelected')?.value,
                            true,
                            false,
                            this.transformMomentToDate(this.profileForm.get('publicationDate')?.value),
                            [],
                            this.profileForm.get('solutionSelected')?.value,
                            false);
    }
    return undefined;
  }

  updateValues(assistance: Assistance): Assistance {
    if (assistance && this.profileForm) {
      assistance.label = this.profileForm.get('label')?.value;
      assistance.solution = this.profileForm.get('solutionSelected')?.value;
      assistance.publicationDate = this.transformMomentToDate(this.profileForm.get('publicationDate')?.value);
      assistance.modificationDate = new Date();
      assistance.category = this.profileForm.get('categorySelected')?.value;
      assistance.subCategory = this.profileForm.get('subCategorySelected')?.value;
      assistance.importance = this.profileForm.get('importanceSelected')?.value;
      assistance.status = this.profileForm.get('statusSelected')?.value;
      assistance.published = true;
      assistance.internal = false;
    }
    return assistance;
  }

  private initSolutions(): void {
    this.userContext.getCurrentAccount().applications.forEach(solution => {
      if (solution.hasAccess) {
        const appName = App.getByLabel(solution.applicationName)?.key;
        if (appName) {
          this.solutions.push(appName);
        }
      }
      this.solutions.sort((filterItem1, filterItem2) => filterItem1.localeCompare(filterItem2));
    });
  }

  private transformMomentToDate(dateAsMoment: any): string | null {
    if (dateAsMoment == null || dateAsMoment === '') {
      return null;
    }
    const date = moment(dateAsMoment);
    return date.format('YYYY-MM-DD');
  }

}
